import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PhoneOutlined } from '@ant-design/icons';
import dialogSignalR from '../../services/dialog-signalr';

// Карточки входящих звонков поверх любой страницы
const IncomingCalls = ({ companyId }) => {
    const navigate = useNavigate();
    const [calls, setCalls] = useState([]);

    useEffect(() => {
        const sessionId = localStorage.getItem('sessionId');
        if (!sessionId || companyId == null) return undefined;
        dialogSignalR.joinCompany(sessionId, {
            onIncomingCall: (dto) => {
                if (!dto?.externalId) return;
                setCalls((list) => {
                    if (dto.state === 'ended')
                        return list.filter((item) => item.externalId !== dto.externalId);
                    return [...list.filter((item) => item.externalId !== dto.externalId), dto];
                });
            },
        }).catch(() => {});
        return undefined;
    }, [companyId]);

    if (calls.length === 0) return null;

    return (
        <div className="call-popups">
            {calls.map((call) => (
                <div className="call-popup" key={call.externalId}>
                    <div className="call-popup-title"><PhoneOutlined /> Входящий звонок</div>
                    <button
                        type="button"
                        className="call-popup-name"
                        onClick={() => call.dialogId && navigate(`/dialogs?id=${call.dialogId}`)}
                    >
                        {call.name || call.phone || 'Неизвестный номер'}
                    </button>
                    {call.phone && <div className="call-popup-phone">{call.phone}</div>}
                    {call.created && <div className="call-popup-note">Создан новый контакт</div>}
                    {call.userName && <div className="call-popup-note">Сотрудник: {call.userName}</div>}
                    <div className="call-popup-tasks">
                        {(call.tasks ?? []).length === 0 && <div className="call-popup-note">Открытых задач нет</div>}
                        {(call.tasks ?? []).map((task) => (
                            <button
                                type="button"
                                key={task.id}
                                className="call-popup-task"
                                onClick={() => navigate(`/tasks?id=${task.id}`)}
                            >
                                {task.name}
                                {task.statusName ? ` · ${task.statusName}` : ''}
                            </button>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default IncomingCalls;
